// 路由映射表
import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import Layout from "../layouts/BasicLayout";
import LoadingDom from "@/components/UI/LoadingDom";

// 包装组件，添加Suspense
const withSuspense = (Component: React.ComponentType<any>) => {
  return () => (
    <Suspense fallback={<LoadingDom />}>
      <Component />
    </Suspense>
  );
};

const Workbench = lazy(() => import("@/pages/work-bench")); // 工作台
const MyAiRole = lazy(() => import("@/pages/my-ai-role")); // 我的AI角色页
const AiLiveShow = lazy(() => import("@/pages/ai-live-show")); // AI口播视频页
const AiMarket = lazy(() => import("@/pages/ai-market")); // AI营销视频页
const AiProduct = lazy(() => import("@/pages/ai-product")); // AI产品视频页
const MarketingPositioningTemplates = lazy(() => import("@/pages/marketing-position-template")); // 营销定位与模板页
const MaterialVideo = lazy(() => import("@/pages/Material/VideoPage/index")); // 视频模板页
const MaterialAddVideo = lazy(() => import("@/pages/Material/VideoDesignTemplate/index")); // 视频设计页
const VideoPublish = lazy(() => import("@/pages/VideoPublish/index")); // 视频发布页
const TextToVideo = lazy(() => import("@/pages/text-to-video")); // 文本转视频页
const ImageToVideo = lazy(() => import("@/pages/image-to-video")); // 图片转视频页
const MyAIVideoCollection = lazy(() => import("@/pages/my-video-collection")); // 我的视频集合页
const ConsumeDetails = lazy(() => import("@/pages/consume-details")); // 算力消耗明细页
const UserCenter = lazy(() => import("@/pages/UserCenter")); // 用户中心页
const AgreementPage = lazy(() => import("@/pages/agreement"));

// 包装组件
const WorkbenchWrapper = withSuspense(Workbench);
const MyAiRoleWrapper = withSuspense(MyAiRole);
const AiLiveShowWrapper = withSuspense(AiLiveShow);
const AiMarketWrapper = withSuspense(AiMarket);
const AiProductWrapper = withSuspense(AiProduct);
const MarketingPositioningTemplatesWrapper = withSuspense(MarketingPositioningTemplates);
const MaterialVideoWrapper = withSuspense(MaterialVideo);
const MaterialAddVideoWrapper = withSuspense(MaterialAddVideo);
const VideoPublishWrapper = withSuspense(VideoPublish);
const TextToVideoWrapper = withSuspense(TextToVideo);
const ImageToVideoWrapper = withSuspense(ImageToVideo);
const MyAIVideoCollectionWrapper = withSuspense(MyAIVideoCollection);
const ConsumeDetailsWrapper = withSuspense(ConsumeDetails);
const UserCenterWrapper = withSuspense(UserCenter);
const AgreementPageWrapper = withSuspense(AgreementPage);
/**
 * 路由映射表
 */
const routers = [
  {
    path: "/",
    element: <Navigate to="/work-bench" />,
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/work-bench",
        element: <WorkbenchWrapper />,
      },
      {
        path: "/my-ai-role",
        element: <MyAiRoleWrapper />,
      },
      {
        path: "/ai-live-show",
        element: <AiLiveShowWrapper />,
      },
      {
        path: "/ai-market",
        element: <AiMarketWrapper />,
      },
      {
        path: "/ai-product",
        element: <AiProductWrapper />,
      },
      {
        path: "/marketing-position-template/:type",
        element: <MarketingPositioningTemplatesWrapper />,
      },
      {
        path: "/marketing-position-template/material/video/:id",
        element: <MaterialVideoWrapper />,
      },
      {
        path: "/marketing-position-template/material/video-add/:id/:editType",
        element: <MaterialAddVideoWrapper />,
      },
      {
        path: "/Video-publish",
        element: <VideoPublishWrapper />,
      },
      {
        path: "/text-to-video",
        element: <TextToVideoWrapper />,
      },
      {
        path: "/image-to-video",
        element: <ImageToVideoWrapper />,
      },
      {
        path: "/my-video-collection",
        element: <MyAIVideoCollectionWrapper />,
      },
      {
        path: "/consume-details",
        element: <ConsumeDetailsWrapper />,
      },
      {
        path: "/user",
        element: <UserCenterWrapper />,
      },
    ],
  },
  {
    path: "/agreement/:type",
    element: <AgreementPageWrapper />,
  },
];
export default routers;
